import { LoginForm } from '@/components/forms/login.form.component';

function Login() {
  return <LoginForm />;
}

export default Login;
